import React from "react";
import { useNotificationContext } from "../../contexts/notification-context";
import { useRouteNavigation } from "../../lib/common/routes";
import { useServiceContext } from "../../contexts/service";
import { topMenuNotificationsNumberStyle } from "../sections/main-page/top-menu";

type TMessageNotificationsProps = {
    isMobile: boolean;
    isLandingPage?: boolean;
};
export const MessagesNotifications = ({ isMobile, isLandingPage = false }: TMessageNotificationsProps) => {
    const { messagesList } = useNotificationContext();
    const {
        chats: { openCloseMessageCenter },
    } = useServiceContext();
    const { navigateRouteClickHandler } = useRouteNavigation();

    const clickHandler = (e: React.MouseEvent) => {
        if (isMobile) {
            navigateRouteClickHandler("conversations", e);
        } else {
            openCloseMessageCenter();
        }
    };

    return (
        <button className="btn nav-row rounded-3 border-0 top-menu__icon-action" onClick={clickHandler} style={{ position: "relative" }}>
            <i className={`fa-regular fa-comment fs-4 ${isLandingPage ? "text-muted" : "text-white"}`}></i>
            <span className="badge bg-danger top-menu__icon-badge" style={topMenuNotificationsNumberStyle}>
                {messagesList.length}
            </span>
        </button>
    );
};
